import { defineMessages } from "react-intl";

export const messages = defineMessages({
  unsupportedCurrencyError: {
    id: "ads_manager.bid_validation.currency.unsupported",
    defaultMessage: "Unsupported currency for bid validation.",
    description: "Validation error when bid validation does not support the ad-account currency.",
  },
  maxBidRangeError: {
    id: "ads_manager.bid_validation.maximum_bid.range",
    defaultMessage: "Enter a max bid between {minimumAmount} and {maximumAmount}.",
    description: "Validation error when a maximum cost-per-click bid is outside the allowed range.",
  },
  numericMaxBidError: {
    id: "ads_manager.bid_validation.maximum_bid.numeric",
    defaultMessage: "Enter a valid numeric max bid.",
    description: "Validation error when a maximum cost-per-click bid is not numeric.",
  },
  wholeMaxBidError: {
    id: "ads_manager.bid_validation.maximum_bid.whole_amount",
    defaultMessage: "Enter a whole amount for {currency}.",
    description:
      "Validation error when a bid for a zero-decimal currency contains non-zero decimal places.",
  },
  cpmBidRangeError: {
    id: "ads_manager.bid_validation.cpm_bid.range",
    defaultMessage: "Enter a CPM bid between {minimumAmount} and {maximumAmount}.",
    description: "Validation error when a cost-per-thousand-impressions bid is outside the range.",
  },
  numericCpmBidError: {
    id: "ads_manager.bid_validation.cpm_bid.numeric",
    defaultMessage: "Enter a valid numeric CPM bid.",
    description: "Validation error when a cost-per-thousand-impressions bid is not numeric.",
  },
});
